(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stb-ambassador-banner"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.dataset.ready)return;
    root.dataset.ready='true';
    fetch('https://stb-world.osmanderick.chatgpt.site/api/ambassador-directory',{cache:'no-store'}).then(function(r){if(!r.ok)throw Error();return r.json()}).then(function(members){members.forEach(function(m){var card=root.querySelector('[data-member-id="'+m.id+'"]');if(!card)return;card.href='/pages/ambassadors#'+m.id;card.querySelector('[data-member-name]').textContent=m.name;card.querySelector('[data-member-market]').textContent=m.market;if(m.photo){var u=new URL(m.photo);if(u.protocol==='https:'){var image=document.createElement('img');image.src=u.href;image.alt=m.name;image.width=44;image.height=44;image.loading='lazy';card.querySelector('.stb-amb-strip-avatar').replaceChildren(image);}}})}).catch(function(){});
    var track=root.querySelector('[data-track]'),toggle=root.querySelector('[data-toggle]'),reduced=window.matchMedia('(prefers-reduced-motion: reduce)'),paused=reduced.matches,hovered=false,focused=false,holdUntil=0;
    function sync(){toggle.textContent=paused?toggle.dataset.play:toggle.dataset.pause;toggle.setAttribute('aria-pressed',String(paused));}
    function advance(direction){var cards=Array.from(track.children),current=cards.reduce(function(best,card,i){return Math.abs(card.offsetLeft-track.offsetLeft-track.scrollLeft)<Math.abs(cards[best].offsetLeft-track.offsetLeft-track.scrollLeft)?i:best;},0),max=track.scrollWidth-track.clientWidth,target=cards[current+direction];if(direction>0&&track.scrollLeft>=max-3){track.scrollTo({left:0,behavior:'auto'});return;}if(direction<0&&track.scrollLeft<=3){track.scrollTo({left:max,behavior:reduced.matches?'auto':'smooth'});return;}if(target)track.scrollTo({left:Math.min(max,Math.max(0,target.offsetLeft-track.offsetLeft)),behavior:reduced.matches?'auto':'smooth'});}
    root.querySelector('[data-next]').addEventListener('click',function(){holdUntil=Date.now()+8000;advance(1)});
    root.querySelector('[data-previous]').addEventListener('click',function(){holdUntil=Date.now()+8000;advance(-1)});
    toggle.addEventListener('click',function(){paused=!paused;sync()});
    root.addEventListener('pointerenter',function(e){if(e.pointerType==='mouse')hovered=true});root.addEventListener('pointerleave',function(){hovered=false});root.addEventListener('focusin',function(){focused=true});root.addEventListener('focusout',function(e){focused=root.contains(e.relatedTarget)});track.addEventListener('pointerdown',function(){holdUntil=Date.now()+8000});track.addEventListener('wheel',function(){holdUntil=Date.now()+8000},{passive:true});reduced.addEventListener('change',function(){if(reduced.matches)paused=true;sync()});
    sync();var timer=setInterval(function(){if(!root.isConnected){clearInterval(timer);return;}var box=root.getBoundingClientRect();if(!paused&&!hovered&&!focused&&!document.hidden&&Date.now()>holdUntil&&box.bottom>0&&box.top<innerHeight)advance(1)},Number(root.dataset.interval)||4000);
  }
  function scan(){document.querySelectorAll('[data-stb-ambassador-slider]').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan);else scan();document.addEventListener('shopify:section:load',scan);
})();

  } catch(e) { console.error(e); }
})();
})();
